import { AppData } from '@ai-platform/utils';

import { AvatarSize } from './UserContext.types';

const validStatuses = ['VALID', 'NEED_RESET'];

export function isAuthorizedByBlackbox(user: AppData['user']) {
    return Boolean(
        user &&
            // Не должно быть ошибки
            (!user.error || user.error === 'OK') &&
            // Должен быть статус 'VALID' или 'NEED_RESET'
            (!user.status || validStatuses.includes(user.status)),
    );
}

export function getAvatarSrc(avatar?: string, size: AvatarSize = AvatarSize.Small) {
    const sizeSuffixes: Record<AvatarSize, string> = {
        [AvatarSize.Small]: '/islands-68',
        [AvatarSize.Medium]: '/islands-retina-50',
        [AvatarSize.Big]: '/islands-200',
    };

    const avatarId = avatar || '18057972/NbnfpFSzqQp5FluiuEdXK61dkg-1';

    return `https://avatars.mds.yandex.net/get-yapic/${avatarId}${sizeSuffixes[size]}`;
}
